jQuery(document).ready(function($){

	 $('.slick-slider').on('click', '.slick-slide', function (e) {
    e.stopPropagation();
    var index = $(this).data("slick-index");
    if ($('.slick-slider').slick('slickCurrentSlide') !== index) {
      $('.slick-slider').slick('slickGoTo', index);
    }
  });

  // play/pause functionality for full width videos
	$('.block-video-full.new-vid').click (function (e) {
		e.preventDefault(); // <=====================
		var videoBlock = $(this);

		if (videoBlock.hasClass('video-file')) {
			var video = videoBlock;
		} else {
			var video = videoBlock.find('video');
		}
		
		video.trigger('play');
		videoBlock.removeClass('new-vid');
		video.attr('controls', true);

	});
});

document.addEventListener("DOMContentLoaded", function(event) {

  window.addEventListener("load", function(e) {

  gsap.registerPlugin(ScrollTrigger);
  gsap.registerPlugin(DrawSVGPlugin);

  let fade = gsap.utils.toArray('.fade');

  fade.forEach((text, i) => {
  	gsap.to(text, {
			opacity: 1,
			y: 0,
			ease: "back.out(1.7)",
			scrollTrigger: {
				trigger: text
			}
		});
  });

  let chartTl = gsap.timeline({
  	scrollTrigger: {
  		trigger: '.chart',
  		start: '-=350'
  	}
  });

  	chartTl.to('.line', {
		  opacity: 1,
		  stagger: 0.2,
		  x: 0,
		  y: 0
		}, "-=0.3");

		chartTl.to('.text', {
		  opacity: 1,
		  stagger: 0.1,
		  x: 0
		}, "<");

		chartTl.to('.highlight-top', {
		  opacity: 1,
		  width: 86.2,
		}, "<25%");

		chartTl.to('.highlight-bottom', {
		  opacity: 1,
		  width: 177,
		}, "<25%");

  }, false);

	var pipeTl = gsap.timeline({
	  scrollTrigger: {
	    scrub: 1,
	    trigger: '.pipe-container',
	    start: '-250px center',
	    end: '500px',
	    markers: false
	  }
	});

	gsap.set('.path', {visibility: 'visible'});

	pipeTl.from('.path', 1, {
	  stagger: 3,
	  drawSVG:0,
	  delay:0
	}, 0.3);
 
});